import { useState, useEffect } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer'

function Project_Drone() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className='px-8 md:px-20 lg:px-40'>
    
    <Navbar />

    <section id='home' className='mt-40 flex flex-col max-w-screen-md mx-auto text-justify'>
        <h1 id='title' className='text-2xl md:text-3xl font-medium text-teal-500'>AeroHaptix: A Wearable Vibrotactile Feedback System for Enhancing Collision Avoidance in UAV Teleoperation</h1>
        <h3 id='authors' className='text-lg mt-10 md:text-xl'>Bingjian Huang, Siyi Ren, Yuewen Luo, Qilong Cheng, Hanfeng Cai, Yeqi Sang, Mauricio Sousa, Paul H. Dietz, Daniel Wigdor</h3>
    </section>
    <section id='content' className='mt-10 max-w-screen-md mx-auto text-justify' >
        <p className='text-lg mt-3'>
        Haptic feedback enhances collision avoidance by providing directional obstacle information to operators during unmanned aerial vehicle (UAV) teleoperation. However, such feedback is often rendered via haptic joysticks, which are unfamiliar to UAV operators and limited to single-direction force feedback. Additionally, the direct coupling between the input device and the feedback method diminishes operators’ sense of control and induces oscillatory movements. To overcome these limitations, we propose AeroHaptix, a wearable haptic feedback system that uses spatial vibrations to simultaneously communicate multiple obstacle directions to operators, without interfering with their input control. The layout of vibrotactile actuators was optimized via a perceptual study to eliminate perceptual biases and achieve uniform spatial coverage. A novel rendering algorithm, MultiCBF, extended control barrier functions to support multi-directional feedback. Our system evaluation showed that compared to a no-feedback condition, AeroHaptix effectively reduced the number of collisions and input disagreement. Furthermore, operators reported that AeroHaptix was more helpful than force feedback, with improved situational awareness and comparable workload.
        </p>
    </section>
    <section id='content' className='min-h-screen mt-10 max-w-screen-md mx-auto text-justify' >
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>System design</p>
          <img src='project_drone_suit_overview.png' layout="fill" objectFit="cover" />      
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>Perceptual study data collection</p>
          <img src='project_drone_data_collection.png' layout="fill" objectFit="cover" />      
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>User study scene</p>
          <img src='project_drone_test_scene.png' layout="fill" objectFit="cover" />
        </div>
        <div>
          <p className='text-md mt-3'>Trajectory comparisons across three feedback conditions, no feedback (white), force feedback (blue), vibrotactile feedback (green)</p>
          <img src='project_drone_trajectories.png' layout="fill" objectFit="cover" />  
        </div>

    </section>

    <Footer />

    </main>
  );
}

export default Project_Drone;
